/**
 * @generated SignedSource<<a3142971a5bfb13db9168c7dccd0f5a7>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type CreateNewExternalTicketPaneMutation$variables = {
  blockKey: string;
  destinationInfo: any;
  noteId: string;
  title: string;
};
export type CreateNewExternalTicketPaneMutation$data = {
  readonly sendActionItemToIntegration: {
    readonly clientMutationId: string | null;
  } | null;
};
export type CreateNewExternalTicketPaneMutation = {
  response: CreateNewExternalTicketPaneMutation$data;
  variables: CreateNewExternalTicketPaneMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "blockKey"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "destinationInfo"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "noteId"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "title"
},
v4 = [
  {
    "alias": null,
    "args": [
      {
        "fields": [
          {
            "kind": "Variable",
            "name": "blockKey",
            "variableName": "blockKey"
          },
          {
            "kind": "Variable",
            "name": "destinationInfo",
            "variableName": "destinationInfo"
          },
          {
            "kind": "Literal",
            "name": "integrationProvider",
            "value": "CLICKUP"
          },
          {
            "kind": "Variable",
            "name": "noteId",
            "variableName": "noteId"
          },
          {
            "kind": "Variable",
            "name": "title",
            "variableName": "title"
          }
        ],
        "kind": "ObjectValue",
        "name": "input"
      }
    ],
    "concreteType": "SendActionItemToIntegrationPayload",
    "kind": "LinkedField",
    "name": "sendActionItemToIntegration",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "clientMutationId",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "CreateNewExternalTicketPaneMutation",
    "selections": (v4/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Operation",
    "name": "CreateNewExternalTicketPaneMutation",
    "selections": (v4/*: any*/)
  },
  "params": {
    "cacheID": "e0030c8442e5fa6634a6f7529adcbbc7",
    "id": null,
    "metadata": {},
    "name": "CreateNewExternalTicketPaneMutation",
    "operationKind": "mutation",
    "text": "mutation CreateNewExternalTicketPaneMutation(\n  $blockKey: String!\n  $noteId: ID!\n  $title: String!\n  $destinationInfo: JSON!\n) {\n  sendActionItemToIntegration(input: {blockKey: $blockKey, noteId: $noteId, title: $title, destinationInfo: $destinationInfo, integrationProvider: CLICKUP}) {\n    clientMutationId\n  }\n}\n"
  }
};
})();

(node as any).hash = "5bfb17fde49305d4f0f6df95366c66b5";

export default node;
